import { UnicUserModel } from "@courses-models/user";

/**
 * Extend the base UnicUserModel, making sure that the authentication token is
 * exposed publicly.
 */
export class AuthenticatedUnicUserModel extends UnicUserModel {
    /**
     * Contains information about the authentication of this user.
     */
    public readonly auth: {
        /**
         * Specifies which LoginConnector profile was used, when the user was
         * being authenticated.
         */
        readonly profile: string;

        /**
         * Specifies the token returned by the LoginConnector, when the user was
         * being authenticated.
         */
        readonly token: string;
    };

    /**
     * Cache data from the base user model and save the token as well, when a
     * new instance of the AuthenticatedUnicUserModel is created.
     */
    constructor(base: UnicUserModel, auth: { profile: string; token: string }) {
        super({
            id: base.id,
            institutionId: base.institutionId,
            mail: base.mail,
            name: base.name,
            userType: base.userType,
        });

        this.auth = auth;
    }
}
